<template>
    <v-card elevation="0" class="pa-0 ma-0">
        <v-card-title>{{ surveySelected.text }}</v-card-title>
        <v-progress-linear indeterminate color="black" v-if="loading"></v-progress-linear>
        <v-card v-for="question in surveySelected.data.questions" :key="question.id" class="pa-0" elevation="0">
            <v-card-title>{{ question.question }}</v-card-title>
            <v-simple-table dense>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left" v-for="header in headers" :key="header.text">
                                {{ header.text }}
                            </th>
                        </tr>
                    </thead>
                    <tbody v-if="statistics.length">
                        <tr v-for="statistic in statistics.find(s => s.question === question.id).options" :key="statistic.question">
                            <td v-for="header in headers" :key="header.text" :style="`width: ${100 / headers.length}%`">
                                {{ statistic[header.value] }}
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-card>
    </v-card>
</template>

<script>
    import SurveyResponsesProvider from '../../../providers/SurveyResponseProvider';

    export default {
        name: "SurveyResponsesStatistics",
        props: {
            needUpdate: {
                type: Boolean,
                required: true
            },
            filters: {
                type: Object,
                required: true
            },
            surveySelected: {
                type: Object,
                required: true
            }
        },
        data: () => ({
            headers: [
                {text: 'Opción', value: 'option'}, 
                {text: 'Cantidad de respuestas', value: 'responses'},
                {text: 'Porcentaje (%)', value: 'percentage'}
            ],
            items: [],
            statistics: [],
            loading: false
        }),
        mounted() {
            this.fetchStatistics();
        },
        watch: {
            needUpdate: {
                handler(newValue) {
                    if (newValue) {
                        this.fetchStatistics();
                    }
                },
                immediate: true
            }
        },
        methods: {
            async fetchStatistics() {
                this.loading = true
                try {
                    const {data: {fetchStatistics}} = await SurveyResponsesProvider.fetchStatistics(this.surveySelected.value, this.filters)
                    this.statistics = this.surveySelected.data.questions.map(question => {
                        return {question: question.id, options: question.options.map(option => ({
                            option: option.value,
                            responses: fetchStatistics.questions.find(q => q.question === question.id && q.option === option.value)?.quantity || 0,
                            percentage: `${((fetchStatistics.questions.find(q => q.question === question.id && q.option === option.value)?.quantity || 0) / (fetchStatistics.totalResponses || 1) * 100).toFixed(2)} %`
                        }))}
                    })
                } catch (error) {
                    console.error('Error fetching statistics:', error)
                } finally {
                    this.loading = false
                    this.$emit('update:needUpdate', false)
                }
            }
        }
    }
</script>